import React from "react";
import AskOpusOrb from "@src/features/assistantChat/AskOpusOrb";
import { useAskOpusOrbState } from "@src/features/assistantChat/useAskOpusOrbState";
import type { OrbStateId } from "@src/features/assistantChat/afterimage/orb";

type Props = {
  /** Rendered size in px. */
  size?: number;
  /** Defaults to Ask Opus's live state (thinking while a turn runs). */
  state?: OrbStateId;
  /** One still frame per state, never animated (nav and header). */
  still?: boolean;
  className?: string;
};

/** The orb at icon scale, showing what Ask Opus is doing. Decorative. */
const AskOpusOrbIcon: React.FC<Props> = ({
  size = 20,
  state,
  still,
  className,
}) => {
  const live = useAskOpusOrbState();
  return (
    <AskOpusOrb
      size={size}
      state={state ?? live}
      still={still}
      className={className}
    />
  );
};

export default AskOpusOrbIcon;
